export const SET_TERM_STATEMENT_STORE = "SET_TERM_STATEMENT_STORE";
export const SET_TERM_STATEMENT_RESET = "SET_TERM_STATEMENT_RESET";
// Lay ds sổ tất toán
export const FETCH_TERM_DEPOSIT_STATEMENT_REQUEST = "FETCH_TERM_DEPOSIT_STATEMENT_REQUEST";
export const FETCH_TERM_DEPOSIT_STATEMENT_SUCCESS = "FETCH_TERM_DEPOSIT_STATEMENT_SUCCESS";
export const FETCH_TERM_DEPOSIT_STATEMENT_FAILURE = "FETCH_TERM_DEPOSIT_STATEMENT_FAILURE";

// Kiểm tra tất toán
export const FETCH_TERM_DEPOSIT_STATEMENT_CREATE_REQUEST = "FETCH_TERM_DEPOSIT_STATEMENT_CREATE_REQUEST";
export const FETCH_TERM_DEPOSIT_STATEMENT_CREATE_SUCCESS = "FETCH_TERM_DEPOSIT_STATEMENT_CREATE_SUCCESS";
export const FETCH_TERM_DEPOSIT_STATEMENT_CREATE_FAILURE = "FETCH_TERM_DEPOSIT_STATEMENT_CREATE_FAILURE";

// Xác nhận tất toán
export const FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_REQUEST = "FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_REQUEST";
export const FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_SUCCESS = "FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_SUCCESS";
export const FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_FAILURE = "FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_FAILURE";

// Xác thực tất toán
export const FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_REQUEST = "FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_REQUEST";
export const FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_SUCCESS = "FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_SUCCESS";
export const FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_FAILURE = "FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_FAILURE";
